import { render } from "./TaskBar.vue?vue&type=template&id=206487a5"
import script from "./TaskBar.vue?vue&type=script&lang=js"
export * from "./TaskBar.vue?vue&type=script&lang=js"

import "./TaskBar.vue?vue&type=style&index=0&id=206487a5&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__